import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

/* eslint-disable */
import { observer, inject } from 'mobx-react'
/* eslint-enable */

import style from './style'

import ContactForm from './partials/ContactForm'
import Success from './partials/Success'

import Sitemap from '../partials/Sitemap'

const sitemapHeader = [
  { url: '/', title: 'Home' },
  { url: '/contact', title: 'Contact' }
]

@inject('Ticket')
@observer
export class ContactScreen extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        fullName: '',
        email: '',
        title: '',
        content: '',
        captcha: false
      }
    }
  }

  onFormSubmit (e) {
    e.preventDefault()

    if (!this.state.editor.captcha) {
      return
    }

    this.props.Ticket.postContactForm(this.state.editor)
  }

  onCaptchaVerify () {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        captcha: true
      }
    })
  }

  onInputChange (e) {
    e.preventDefault()

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  render () {
    const response = this.props.Ticket.responses.contact || { data: {} }

    if (response.statusCode && response.statusCode === 201) {
      return (
        <section className={css(style.main.section)}>
          <Container>
            <Success />
          </Container>
        </section>
      )
    }

    return [
      <Sitemap key={0} sitemap={sitemapHeader} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row>
            <Col xs='12' md='8'>
              <h3 className={css(style.headers.h3)}>
                <strong className={css(style.headers.strong)}>
                  Questions or comments?
                </strong>{' '}
                Let us know!
              </h3>
              <Row>
                <Col>
                  <p className={css(style.error.p)}>{response.data.message}</p>
                </Col>
              </Row>
              <ContactForm
                editor={this.state.editor}
                onCaptchaVerify={this.onCaptchaVerify.bind(this)}
                onInputChange={this.onInputChange.bind(this)}
                onFormSubmit={this.onFormSubmit.bind(this)}
              />
            </Col>
          </Row>
        </Container>
      </section>
    ]
  }
}

export default ContactScreen



// WEBPACK FOOTER //
// ./src/components/Contact/index.js